module.exports = __webpack_public_path__ + "static/media/JS1.d1b78c11.PNG";